import React from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import HeroCarousel from "./HeroCarousel";
import "../../styles/HeroModule.css";
import { isLoggedIn } from "../../utility/UserUtils";

const ChevronRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
    />
  </svg>
);

const HeroModule = () => {
  const navigate = useNavigate();
  const loggedIn = isLoggedIn();

  const handleSignupRedirect = () => navigate("/signup");
  const handleLoginRedirect = () => navigate("/login");

  return (
    <div className="hero-section d-flex align-items-center bg-primary text-white">
      <Container fluid className="h-100">
        <Row className="align-items-stretch m-0 h-100 no-gutters">
          {/* Left Section */}
          <Col md={5} className="hero-left-section">
            <div className="hero-left-content">
              <h1 className="hero-heading">
                WOMEN IN <br />
                SEMICONDUCTOR <br />
                ECOSYSTEM
              </h1>
              <p className="hero-subtitle">
                Be part of a vibrant community that empowers, connects, and elevates women in the 
                semiconductor ecosystem. At WiSE, we’re building pathways from campus to corporate to 
                career — through mentorship, collaboration, connection and opportunity. Join us in shaping 
                a more inclusive and innovative future. 
              </p>

              {!loggedIn && (
                <div className="mt-4 d-flex flex-column gap-3">
                  <div className="d-flex flex-wrap gap-3">
                    <Button
                      className="btn-secondary"
                      onClick={handleSignupRedirect}
                    >
                      <span className="icon-circle">
                        <ChevronRightIcon />
                      </span>{" "}
                      Join Our Community
                    </Button>

                    <Button
                      className="btn-primary"
                      onClick={handleLoginRedirect}
                    >
                      <span className="icon-circle">
                        <ChevronRightIcon />
                      </span>
                      Login
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Col>

          {/* Right Section */}
          <Col
            xs={12}
            md={7}
            className="position-relative mb-4 mb-md-0 p-0 hero-carousel-container"
          >
            <HeroCarousel />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroModule;
